import React from 'react';
import ReactSelect, { Styles, Props } from 'react-select';

const customSelectStyles: Styles<any, false> = {
  control: (provided, state) => {
    const { isFocused } = state;
    return {
      ...provided,
      '&:hover': {
        borderColor: isFocused ? '' : 'var(--indigo-400)',
      },
      border: isFocused
        ? '2px solid var(--color-primary)'
        : '2px solid var(--coolGray-300)',
      outline: 'none',
      boxShadow: isFocused
        ? '0 0 0px 2px rgba(255, 255, 255, 0.5), 0 0 1px 3px var(--indigo-200)'
        : '',
      borderRadius: '0.6rem / 0.55rem',
    };
  },
  singleValue: (provided) => ({ ...provided, color: 'var(--color-text)' }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '0.6rem / 0.55rem',
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '0.5rem',
  }),
  option: (provided, state) => {
    const { isSelected, isFocused } = state;
    const getOptionBGColor = () => {
      if (isSelected) return 'var(--color-primary)';
      if (isFocused) return 'var(--indigo-50)';
      return '';
    };
    const getActiveOptionBGColor = () => {
      if (isSelected) return 'var(--indigo-700)';
      if (isFocused) return 'var(--indigo-100)';
      return '';
    };
    const getOptionColor = () => {
      if (isSelected) return 'var(--color-white)';
      if (isFocused) return 'var(--color-primary)';
      return '';
    };
    return {
      ...provided,
      borderRadius: '0.5rem / 0.45rem',
      padding: '0.5rem 0.7rem',
      lineHeight: '1',
      marginBottom: '2px',
      backgroundColor: getOptionBGColor(),
      color: getOptionColor(),
      '&:last-child': {
        marginBottom: '0',
      },
      '&:active': {
        backgroundColor: getActiveOptionBGColor(),
      },
    };
  },
  dropdownIndicator: (provided, state) => {
    const { isFocused } = state;
    return {
      ...provided,
      '&:hover': {
        color: isFocused ? '' : 'var(--indigo-400)',
      },
      color: isFocused ? 'var(--color-primary)' : 'var(--coolGray-300)',
    };
  },
  indicatorSeparator: (provided) => ({
    ...provided,
    // backgroundColor: 'var(--coolGray-300)',
    display: 'none',
  }),
};

const Select: React.FC<Props> = (selectProps) => {
  return <ReactSelect styles={customSelectStyles} {...selectProps} />;
};

export default Select;
